var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"title":_vm.$t('global.redis'),"logo":"redis"}},[_c('CardListContent',{attrs:{"list":_vm.getList()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }